import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Params } from '@angular/router';

import { Subscription } from 'rxjs';

import dayjs from 'dayjs';
import _ from 'lodash';

import { BranchResponseDto, BranchTypeEnumText, PaidByEnumText, PurchaseResponseDto, purchasesGetStatusEnum, PurchasesService, PurchaseStatusEnumText, UserRoleResponseDto } from '@api';

import { GlobalDataService } from '@core-service';
import { DefaultModule, PrimeModule } from '@module';
import { InitialNameService, TranslationsPipe } from '@shared';
import { BranchDropdownComponent } from '@shared/dropdown/branches-dropdown.component';
import { ProductCategoryDropdownComponent } from '@shared/dropdown/product-category-dropdown.component';
import { UserDropdownComponent } from '@shared/dropdown/user-dropdown.component';

import { BaseFeatureGridComponent, CoreStorageService, DatePickerComponent, DatePipe, DynamicDropdownComponent, FileImageUploadComponent, FilterSectionComponent, GridComponent, HeaderPageComponent, LibModalModule, PopupService, Sort, ValueField } from 'pn-core-code';

import { InputNumber } from 'primeng/inputnumber';
import { Tag } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';

interface PropType {
  id: string;
  memberId: string;
  memberName: string;
  purchaseNo: string;
  productCategory: any;
  product: any;
  wdc: any;
  franchise: any;
  createdAt: any;
  totalAmountFrom: any;
  totalAmountNotMoreThan: any;
  recordedBy: any;
  approvedBy: any;
  cashier: any;
  status: any;
  branch: any;
  typeMember: any;
  tier?: any;
  personCount?: any;
}

@Component({
  selector: "shared-purchase-list",
  standalone: true,
  imports: [
    DefaultModule,
    PrimeModule,
    GridComponent,
    HeaderPageComponent,
    FilterSectionComponent,
    DynamicDropdownComponent,
    Tag,
    InputNumber,
    DatePipe,
    TooltipModule,
    LibModalModule,
    FileImageUploadComponent,
    TranslationsPipe,
    BranchDropdownComponent,
    UserDropdownComponent,
    DatePickerComponent,
  ],
  templateUrl: "./shared-purchase-list.component.html",
  styleUrl: "./shared-purchase-list.component.scss",
  providers: [PopupService, InitialNameService],
})
export class SharedPurchaseListComponent extends BaseFeatureGridComponent<PurchaseResponseDto, PropType> implements OnInit, OnDestroy {
  @Input() memberId: string;

  override field: ValueField<PurchaseResponseDto>;
  @ViewChild("fullNameTpl", { static: true }) fullNameTpl: TemplateRef<any>;
  @ViewChild("purchaseNoTpl", { static: true }) purchaseNoTpl: TemplateRef<any>;
  @ViewChild("startDateTpl", { static: true }) startDateTpl: TemplateRef<any>;
  @ViewChild("memberIdTpl", { static: true }) memberIdTpl: TemplateRef<any>;
  @ViewChild("branchTpl", { static: true }) branchTpl: TemplateRef<any>;
  @ViewChild("countTpl", { static: true }) countTpl: TemplateRef<any>;
  @ViewChild("auditorTpl", { static: true }) auditorTpl: TemplateRef<any>;
  @ViewChild("clerkTpl", { static: true }) clerkTpl: TemplateRef<any>;
  @ViewChild("sumAmountTpl", { static: true }) sumAmountTpl: TemplateRef<any>;
  @ViewChild("activeStatusTpl", { static: true }) activeStatusTpl: TemplateRef<any>;
  @ViewChild("actionTpl", { static: true }) actionTpl: TemplateRef<any>;

  @ViewChild("formPaymentResultRecord") formPaymentResultRecord: NgForm;

  branchTypeEnumText = BranchTypeEnumText;
  purchaseStatusEnumText = PurchaseStatusEnumText;
  statusPurchaseType = PurchaseResponseDto.StatusEnum;
  pidByEnumText = PaidByEnumText;
  branchesTypeEnum = BranchResponseDto.TypeEnum;

  statusList: any[] = [
    { id: PurchaseResponseDto.StatusEnum.PendingReview, name: PurchaseStatusEnumText[PurchaseResponseDto.StatusEnum.PendingReview] },
    { id: PurchaseResponseDto.StatusEnum.PendingPayment, name: PurchaseStatusEnumText[PurchaseResponseDto.StatusEnum.PendingPayment] },
    { id: PurchaseResponseDto.StatusEnum.Paid, name: PurchaseStatusEnumText[PurchaseResponseDto.StatusEnum.Paid] },
    { id: PurchaseResponseDto.StatusEnum.Rejected, name: PurchaseStatusEnumText[PurchaseResponseDto.StatusEnum.Rejected] },
  ];

  fileIcon: any;
  locationId: string;
  userGroup: string;

  override sort: Sort = { sortBy: "createdAt", direction: "desc" };

  focusUserGroupSub: Subscription;

  constructor(
    private initialNameService: InitialNameService,
    private purchasesService: PurchasesService,
    private global: GlobalDataService,
    private storage: CoreStorageService,
  ) {
    super();
  }

  override ngOnInit(): void {
    const locationId = this.route.snapshot.paramMap.get("locationId");
    // console.log("รายการรับซื้อ locationId", this.locationId);
    if (locationId) {
      this.locationId = locationId;
    }
    this.focusUserGroupSub = this.global.focusUserGroupSubject.subscribe((data) => {
      if (!data) {
        this.global.getFocusUserGroup();
      } else {
        const tempFocusUserGroup = this.storage.getItem("focus_user_group");
        if (tempFocusUserGroup) {
          const data = JSON.parse(tempFocusUserGroup);
          this.userGroup = data.userGroup;
        } else {
          const userGroupData = JSON.parse(data);
          this.userGroup = userGroupData.userGroup;
        }
      }
    });

    super.ngOnInit();
    this.getData();
  }

  override ngOnDestroy(): void {
    this.focusUserGroupSub && this.focusUserGroupSub.unsubscribe();
  }

  override filterChange(form: NgForm) {
    this.grid.resetPage(1);
    this.getData();
  }

  protected override setColumns(): void {
    this.columns = [
      {
        name: "purchaseDetailList.purchaseNo",
        prop: "purchaseNo",
        sortable: true,
        width: 250,
        cellTemplate: this.purchaseNoTpl,
      },
      {
        name: "membershipNumber",
        prop: "member",
        sortable: true,
        width: 250,
        cellTemplate: this.memberIdTpl,
      },
      {
        name: "purchaseBranch",
        prop: "branch",
        sortable: true,
        cellTemplate: this.branchTpl,
        width: 250,
      },

      {
        name: "purchaseDetailList.purchaseDate",
        prop: "createdAt",
        sortable: true,
        width: 180,
        cellTemplate: this.startDateTpl,
      },
      {
        name: "purchaseDetailList.sumAmount",
        prop: "sumAmount",
        sortable: true,
        width: 180,
        cellTemplate: this.sumAmountTpl,
      },
      {
        name: "purchasingStaff",
        prop: "recordedBy",
        sortable: true,
        cellTemplate: this.clerkTpl,
        width: 200,
      },
      {
        name: "examine",
        prop: "approvedBy",
        sortable: true,
        cellTemplate: this.auditorTpl,
        width: 200,
      },
      {
        name: "purchaseDetailList.cashier",
        prop: "cashier",
        sortable: true,
        cellTemplate: this.countTpl,
        width: 200,
      },
      {
        name: "purchaseDetailList.paymentMethod",
        prop: "status",
        width: 160,
        cellTemplate: this.activeStatusTpl,
      },
      // {
      //   name: '',
      //   prop: '_action',
      //   isFrozen: true,
      //   alignFrozen: 'right',
      //   cellTemplate: this.actionTpl
      // },
    ];

    if (this.locationId) {
      this.columns.splice(2, 1);
    }
  }

  protected override getData(): void {
    console.log("filter userGroup", this.userGroup);
        console.log("this.locationId", this.locationId);
    if (this.dataSub) {
      this.dataSub.unsubscribe();
    }

    this.dataSub = this.purchasesService
      .purchasesGet$(
        this.page.page,
        this.page.perPage,
        this.filter.memberName || undefined,
        this.locationId && (this.userGroup === UserRoleResponseDto.UserGroupEnum.BranchStaffWpn || this.userGroup === UserRoleResponseDto.UserGroupEnum.ExecutiveWpn)
          ? this.locationId
          : this.filter.wdc || undefined, //wpnBranchId
        this.locationId && (this.userGroup === UserRoleResponseDto.UserGroupEnum.BranchExecutiveFranchise || this.userGroup === UserRoleResponseDto.UserGroupEnum.BranchStaffFranchise)
          ? this.locationId
          : this.filter.franchise || undefined, //franchiseBranchId
        undefined, //memberId
        undefined, //memberName
        this.filter.purchaseNo || undefined, //purchaseNo
        this.filter.createdAt ? dayjs(this.filter.createdAt).format("YYYY-MM-DD") : undefined, //createdAt
        this.filter.createdAt ? dayjs(this.filter.createdAt).format("YYYY-MM-DD") : undefined,
        this.filter.totalAmountFrom || undefined, //sumAmountMin
        this.filter.totalAmountNotMoreThan || undefined, //sumAmountMax
        this.filter.recordedBy || undefined, //recordedBy
        this.filter.approvedBy || undefined, //approvedBy
        this.filter.cashier || undefined, //cashier
        this.filter.status || [purchasesGetStatusEnum.pending_review, purchasesGetStatusEnum.pending_payment, purchasesGetStatusEnum.paid, purchasesGetStatusEnum.rejected], //status
        undefined,
        undefined,
        this.sort.sortBy + ',' + this.sort.direction,
      )
      .subscribe((data) => {
        console.log("purchases data", data);
        this.rows = data.purchases;
        this.page.totalCount = data.pagination.allRecord;
      });
  }

  onSubmit(form: NgForm) {}

  override detail(item: PurchaseResponseDto) {
    console.log("this.locationId ===>", this.locationId);
    if (this.locationId) {
      this.router.navigate([this.localize.translateRoute(`/${this.locationId}/purchase`), item.id]);
    } else {
      this.router.navigate([this.localize.translateRoute(`/purchase`), item.id]);
    }
  }

  onPaymentResultRecord(item: PurchaseResponseDto) {
    this.modal.open();
  }

  onCloseForm() {}
}
